import * as THREE from "three";

export class Camera extends THREE.PerspectiveCamera {
  constructor() {
    super(
      50, // viewfield
      window.innerWidth / window.innerHeight, // ratio
      0.2, //near lcip
      100 // far clip
    );

    this.position.set(15, 6, -3);
    this.lookAt(0, 1, 0);
  }
}
